import { Controller } from '@hotwired/stimulus';
import { createEvent } from '../utilities/events';

export default class extends Controller {
  static targets = ['add', 'sub', 'input'];

  connect() {
    this.addTarget.addEventListener('click', this.add.bind(this));
    this.subTarget.addEventListener('click', this.subtract.bind(this));
  }

  add() {
    this.inputTarget.value = Math.min(Number(this.inputTarget.value) + this.getStepValue(), this.getMaxValue());
    this.inputTarget.dispatchEvent(createEvent('input'));
  }

  subtract() {
    this.inputTarget.value = Math.max(Number(this.inputTarget.value) - this.getStepValue(), this.getMinValue());
    this.inputTarget.dispatchEvent(createEvent('input'));
  }

  getMinValue() {
    return Number(this.inputTarget.min || 0);
  }

  getMaxValue() {
    return Number(this.inputTarget.max || 9999);
  }

  getStepValue() {
    return Number(this.inputTarget.step || 1);
  }
}
